import { hasAsciiControlOrSpace } from './validation';

const MAX_URI_BYTES = 8192;

/**
 * `<img>`에 올려도 되는 https 주소만 돌려준다 — 서버가 준 문자열을 그대로 믿지 않는다.
 * 자격 증명·쿼리·해시가 있거나 공백·제어 문자가 섞이거나 너무 길면 버린다.
 */
export function safeImageUri(value: string | null): string | null {
  if (
    !value ||
    new TextEncoder().encode(value).length > MAX_URI_BYTES ||
    hasAsciiControlOrSpace(value)
  )
    return null;
  try {
    const uri = new URL(value);
    return uri.protocol === 'https:' &&
      !!uri.hostname &&
      !uri.username &&
      !uri.password &&
      !uri.search &&
      !uri.hash
      ? uri.toString()
      : null;
  } catch {
    return null;
  }
}
